import Vue from 'vue';
import excisePeriodTransformer from '../../transformers/excisePeriod';
import paginationTransformer from '../../transformers/pagination';
import store from '../../store';
import helpers from '../../utils/helpers';

const success = ({ data }, resolve) => {
  const excisePeriods = excisePeriodTransformer.fetchCollection(data.data);
  const pagination = paginationTransformer.fetch(data.pagination);
  store.dispatch('fetchPaginatedExcisePeriods', { excisePeriods, pagination });
  resolve();
};

const failed = (error, reject) => reject(error);


export default (options = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(helpers.buildUrl('reports/excise_periods', options))
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/report/excisePeriods.js